import { Popover } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import RectangleInfo from './RectangleInfo';
import Text from 'components/Text';

interface PopoverInfoBoxProps {
  content?: React.ReactNode;
  isContact?: boolean;
  buttonText?: string;
}

const PopoverInfoBox = ({ content, isContact, buttonText }: PopoverInfoBoxProps) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover
      content={content}
      title={null}
      trigger='click'
      open={open}
      placement='topLeft'
      onOpenChange={setOpen}
      overlayClassName='custom-popover-no-padding'
    >
      <Button type='button'>
        <InfoBoxContent $isActive={open}>
          <RectangleInfo isActive={open} isContact={isContact} />
          <Text variant='CONTENT_2' className='text'>
            {buttonText}
          </Text>
        </InfoBoxContent>
      </Button>
    </Popover>
  );
};

export default PopoverInfoBox;
const InfoBoxContent = styled.div<{ $isActive?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ $isActive }) => ($isActive ? '#fff' : '#1D2129')};
  }
  .custom-popover-no-padding .ant-popover-inner-content {
    padding: 0;
  }
`;

const Button = styled.button`
  border: none;
  background: none;
`;
